import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  content: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  field: {
    marginBottom: theme.spacing(2)
  },
  uploadArea: {
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: '8px',
    fontSize:
      (
        theme.components?.MuiInputLabel?.styleOverrides?.root as {
          fontSize?: string
        }
      )?.fontSize || '14px',
    padding: '9px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontWeight: 500,
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  },
  proofPreview: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    gap: theme.spacing(2)
  },
  proofMeta: {
    display: 'flex',
    alignItems: 'baseline',
    gap: theme.spacing(1),
    overflow: 'hidden',
    maxWidth: '70%'
  },
  proofName: {
    color: theme.palette.text.primary,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize:
      (
        theme.components?.MuiInputLabel?.styleOverrides?.root as {
          fontSize?: string
        }
      )?.fontSize || '14px',
    paddingLeft: theme.spacing(0.5)
  },
  proofSize: {
    color: theme.palette.text.secondary,
    whiteSpace: 'nowrap'
  },
  proofBtnChange: {
    fontSize: '14px !important',
    width: 'fit-content !important',
    height: 'fit-content !important',
    padding: theme.spacing(1.5, 2) + ' !important'
  },
  submitButton: {
    marginTop: theme.spacing()
  }
}))
